import { axiosPublic } from '../../publicRest'
import { initApollo } from './apollo'
import gql from 'graphql-tag'
import { initialize } from './global-labels'
import { I18nLabelsQuery } from '../types/graphql'

export const getProperties = async () =>
  axiosPublic.get('/portalProperties').then(obj => obj.data)
export const initializeAppManifestWhiteLabel = async () => {
  const manifest = await axiosPublic.get('/manifest.json').then(obj => obj.data)
  const stringManifest = JSON.stringify(manifest)
  const blob = new Blob([stringManifest], { type: 'application/json' })
  const manifestURL = URL.createObjectURL(blob)

  document
    .querySelector('#manifest-placeholder')
    ?.setAttribute('href', manifestURL)

  return manifest
}

export const initializeFaviconAndTitle = (manifest: {
  name?: string
  favicon?: string
}) => {
  const { favicon, name } = manifest

  document.querySelector('#favicon')?.setAttribute('href', String(favicon))
  document.title = String(name)
}

export const initializeI18n = async (client: ReturnType<typeof initApollo>) => {
  const query = await client.query<I18nLabelsQuery>({
    query: gql`
      query I18nLabels {
        i18nLabels {
          key
          value
        }
      }
    `
  })

  initialize(query.data.i18nLabels)
}
